import * as e from "react";
import t from "../lib/IconBase.es.js";
import n from "../defs/GridNine.es.js";
const o = e.forwardRef((r, i) => /* @__PURE__ */ e.createElement(t, { ref: i, ...r, weights: n }));
o.displayName = "GridNineIcon";
const c = o;
export {
  c as GridNine,
  o as GridNineIcon
};
